import { Link } from "react-router-dom";
import { categoryConfigs } from "@/mocks/categories";

const friendLinks = [
  { label: "国家电影局", href: "https://www.chinafilm.gov.cn/" },
  { label: "中国电影资料馆", href: "https://www.cfa.org.cn/" },
  { label: "电影频道", href: "https://www.cctv6.cn/" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950 text-xl">
                <i className="ri-film-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">秋霞电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-400">
              专注于电影资讯与影片推荐的专业影视门户，帮你轻松发现每一部好电影。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">电影分类</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {categoryConfigs.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-background-400 hover:text-accent-300 transition-colors">
                    {c.label}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" className="text-background-400 hover:text-accent-300 transition-colors">首页</Link></li>
              <li><Link to="/news" className="text-background-400 hover:text-accent-300 transition-colors">影视资讯</Link></li>
              <li><Link to="/special/must-watch-2024" className="text-background-400 hover:text-accent-300 transition-colors">精选专题</Link></li>
              <li><Link to="/about" className="text-background-400 hover:text-accent-300 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line"></i></span>
                <a href="mailto:contact@qiuxiamovie.com" className="hover:text-accent-300 transition-colors">contact@qiuxiamovie.com</a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-service-line"></i></span>
                合作邮箱：press@qiuxiamovie.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
                内容服务：全国在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <div className="flex flex-col gap-3 text-xs text-background-500 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2024 秋霞电影 QiuxiaMovie. 保留所有权利。本站资讯与影片信息仅供演示参考。</p>
            <div className="flex flex-wrap items-center gap-4">
              <span>友情链接：</span>
              {friendLinks.map((l) => (
                <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}